module.exports = __webpack_public_path__ + "img/btn-swiper-next-02.0be24919.svg";